import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=919d3d44&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919d3d44')) {
      api.createRecord('919d3d44', component.options)
    } else {
      api.reload('919d3d44', component.options)
    }
    module.hot.accept("./Identifier.vue?vue&type=template&id=919d3d44&", function () {
      api.rerender('919d3d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Identifier.vue"
export default component.exports